import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Auth.css';

import { useGoogleLogin, GoogleLogin,  googleLogout } from '@react-oauth/google';
import { jwtDecode } from "jwt-decode";

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const Register = ({ onRegister }) => {
  const [ user, setUser ] = useState([]); //to handle the user object from google register.
  const [ profile, setProfile ] = useState([]); //to handle the user profile from google register.

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [acceptTerms, setAcceptTerms] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    if (!acceptTerms) {
      setError('Please accept the terms and conditions');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/auth/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });

      const data = await response.json();

      if (response.ok) {
        onRegister(data.token, data.user);
      } else {
        setError(data.error || 'Registration failed');
      }
    } catch (err) {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleSocialRegisterApple = async (provider) => {}

  const handleSocialRegisterGoogle = async (credentialResponse) => {
    //setError('');
    //setIsLoading(true);
    if (!acceptTerms) {
      setError('Please accept the terms and conditions');
      return; }

    const gcontent = JSON.stringify({
          credential: credentialResponse.credential, })
          console.log(gcontent);


    try {
      const response = await fetch(`${API_URL}/auth/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          email: jwtDecode(gcontent).email,
          provider: 'google',
          providerId: jwtDecode(gcontent).sub
        })
      });

      const data = await response.json();
      if (response.ok) {
        onRegister(data.token, data.user);
      }
    } catch (err) {
      setError('Social registration failed');
    }
  
  };

  return (
    <div className="auth-page">
      <div className="cosmic-bg"></div>
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <h1 className="auth-title">🌟 Begin Your Journey 🌟</h1>
            <p className="auth-subtitle">Create an account to unlock your future</p>
          </div>

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="input-group">
              <label className="input-label">📧 Email Address</label>
              <input
                type="email"
                className="auth-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                required
              />
            </div>

            <div className="input-group">
              <label className="input-label">🔒 Password</label>
              <input
                type="password"
                className="auth-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
              <span className="input-hint">Minimum 6 characters</span>
            </div>

            <div className="input-group">
              <label className="input-label">🔒 Confirm Password</label>
              <input
                type="password"
                className="auth-input"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>

            <div className="checkbox-group">
              <input
                type="checkbox"
                id="terms"
                checked={acceptTerms}
                onChange={(e) => setAcceptTerms(e.target.checked)}
                className="auth-checkbox"
              />
              <label htmlFor="terms" className="checkbox-label">
               I accept the <a onClick={() => window.open('/terms', '_blank')} className="link" style={{cursor: 'pointer'}}>Terms & Conditions</a> and <a onClick={() => window.open('/privacy', '_blank')} className="link" style={{cursor: 'pointer'}}>Privacy Policy</a>
              </label>
            </div>

            {error && (
              <div className="error-message">
                <span className="error-icon">⚠️</span>
                {error}
              </div>
            )}

            <button 
              type="submit" 
              className="auth-submit-btn"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-small"></span>
                  <span>Creating account...</span>
                </>
              ) : (
                'Create Account'
              )}
            </button>
          </form>

          <div className="divider">
            <span>or sign up with</span>
          </div>

          <div className="social-btn google">
            <GoogleLogin
            onSuccess={handleSocialRegisterGoogle}
            onError={() => console.log('Google Register Failed')}
            useOneTap={false}
            disabled={loading}
          />
            
          </div>        

          <div className="auth-footer">
            <p>
              Already have an account? 
              <Link to="/login" className="auth-link">Sign In</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;